import { Theme } from "@material-ui/core";
import { createStyles } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

export const InfoDialogStyles = makeStyles((theme: Theme) =>
  createStyles({
    text: {
      textAlign: "justify",
      whiteSpace: "pre-line"
    },
  })
);
